import { DateTime } from "luxon";
import {
  EABFilterImplementationType,
  EABFilterType,
  type FilterOption,
  SQDCActionStatus,
} from "@/graphql";
import type { ActionFilter } from "../FilterTypes";
import OverdueFilterUI from "../ui/OverdueFilterUI.vue";
import OverdueFilterBadge from "../ui/badges/OverdueFilterBadge.vue";

export default class OverdueFilter implements ActionFilter {
  constructor(
    public readonly definitionOfOverdueInHours: number,
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = OverdueFilterBadge;

  static readonly UI = OverdueFilterUI;

  getActionFilter(): FilterOption | undefined {
    return {
      operation: {
        type: this.isNegated ? EABFilterType.AND : EABFilterType.OR,
        filters: [
          {
            filter: {
              type: EABFilterImplementationType.ACTION_STATUS,
              value: {
                value: [SQDCActionStatus.ACT],
                negated: !this.isNegated,
              },
            },
          },
          {
            filter: {
              type: EABFilterImplementationType.ACTION_DEADLINE_SINCE,
              value: {
                value: DateTime.now().minus({ hours: this.definitionOfOverdueInHours }).toISO(),
                negated: this.isNegated ?? false,
              },
            },
          },
        ],
      },
    };
  }
}
